import './index.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import "./globals.css";
import { ThemeProvider } from './context/ThemeContext.jsx'; // Import ThemeProvider
import { AccountDataProvider } from './context/AccountDataProvider.jsx';
import { UserPreferencesProvider } from './context/UserPreferencesContext.jsx';
import { SubscriptionAccessProvider } from './context/SubscriptionAccessContext.jsx';
import { TradeProvider } from './context/TradeProvider.jsx';
import { WatchlistProvider } from './context/WatchlistContext.jsx';

// Register service worker for PWA + push notifications (non-blocking, dynamic import)
if ('serviceWorker' in navigator) {
  import('./lib/pushNotifications')
    .then(({ registerServiceWorker }) => registerServiceWorker())
    .catch(() => {});
}

createRoot(document.getElementById('root')).render(
  //<StrictMode>
    <ThemeProvider>
      <UserPreferencesProvider>
        <SubscriptionAccessProvider>
          <TradeProvider>
            <AccountDataProvider>
              <WatchlistProvider>
                <App />
              </WatchlistProvider>
            </AccountDataProvider>
          </TradeProvider>
        </SubscriptionAccessProvider>
      </UserPreferencesProvider>
    </ThemeProvider>
  //</StrictMode>,
)
